export const FETCH_REQUESTED = "land_for_sale/FETCH_REQUESTED"
export const FETCH_SUCCESS = "land_for_sale/FETCH_SUCCESS"
export const FETCH_FAILED = "land_for_sale/FETCH_FAILED"

export const FILTERS_UPDATED = "land_for_sale/FILTERS_UPDATED"
